<div app-layout class="mt-4 flex flex-col gap-2">
  <div class="mb-2 rounded-xl bg-white p-8 shadow">
    <form [formGroup]="form" class="flex w-full flex-col items-start justify-center">
      <div class="flex w-full lg:grid lg:grid-cols-3 items-center justify-between gap-4 flex-col">
        <app-form-field class="w-full col-span-1">
          <label translate app-label class="text-md! text-theme-900">trilhas.relatorio.curso</label>
          <ng-select
            app-select
            formControlName="course"
            [items]="courses$ | async"
            [loading]="loading.courses$ | async"
            bindLabel="courseTitle"
            bindValue="slug"
            [notFoundText]="'geral.nao-encontrado' | translate"
            [placeholder]="'trilhas.relatorio.selecione-curso' | translate"
            [clearable]="false"
          >
          </ng-select>
        </app-form-field>
        <app-form-field class="w-full col-span-1">
          <label translate app-label class="text-md! text-theme-900">trilhas.relatorio.evento</label>
          <ng-select
            app-select
            formControlName="event"
            [items]="events"
            [loading]="loading.courseData$ | async"
            bindLabel="titulo"
            [notFoundText]="'geral.nao-encontrado' | translate"
            [placeholder]="'trilhas.relatorio.selecione-evento' | translate"
            [clearable]="false"
          >
            <ng-template ng-label-tmp let-item="item">
              <span class="mr-2">{{ item.titulo }}</span>
              <ng-container *ngTemplateOutlet="badgeEventStatus; context: { item }"></ng-container>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
              <div class="my-2 rounded-md border border-gray-200 bg-white p-2 shadow-md">
                <h6 class="mb-2 font-semibold truncate">{{ item.titulo }}</h6>
                <ng-container *ngTemplateOutlet="badgeEventStatus; context: { item }"></ng-container>
                <p class="mt-2 text-wrap">
                  {{ 'trilhas.relatorio.data-inicio' | translate: { data: item.data_inicio | date: 'dd/MM/yyyy' } }}
                  @if (!!item.data_fim) {
                    {{ 'trilhas.relatorio.data-final' | translate: { data: item.data_fim | date: 'dd/MM/yyyy' } }}
                  }
                </p>
              </div>
            </ng-template>
          </ng-select>
          <ng-template #badgeEventStatus let-item="item">
            <span
              class="rounded px-2 py-1 text-xs font-semibold uppercase text-white"
              [ngClass]="{
                'bg-red-400': item.status_progress === StatusProgressEnum.Closed,
                'bg-blue-400': item.status_progress === StatusProgressEnum.InProgress,
                'bg-violet-400': item.status_progress === StatusProgressEnum.Future,
              }"
            >
              {{ onGetStatusEventLabel(item.status_progress) }}
            </span>
          </ng-template>
        </app-form-field>
        <app-form-field class="w-full col-span-1">
          <label translate app-label class="text-md! text-theme-900">trilhas.relatorio.entidade</label>
          <ng-select
            app-select
            formControlName="entities"
            [items]="entities$ | async"
            [loading]="loading.entities$ | async"
            bindLabel="nome"
            [notFoundText]="'geral.nao-encontrado' | translate"
            [placeholder]="'trilhas.relatorio.selecione-entidade' | translate"
            [clearable]="false"
            [multiple]="true"
          ></ng-select>
        </app-form-field>
      </div>
      <div class="flex w-full flex-col items-center justify-between gap-2 md:flex-row">
        @if (!trailsService.uc$.value && !trailsService.ivca$.value) {
          <app-form-field class="w-1/2">
            <label translate app-label class="text-md! text-theme-900">trilhas.relatorio.turma</label>
            <ng-select
              app-select
              formControlName="group"
              [items]="groups$ | async"
              [loading]="loading.groups$ | async"
              bindLabel="nome"
              bindId="id"
              groupBy="entidade_nome"
              [notFoundText]="'geral.nao-encontrado' | translate"
              [placeholder]="'trilhas.relatorio.selecione-turma' | translate"
            ></ng-select>
          </app-form-field>
        }
        <app-form-field [ngClass]="{ 'w-1/2': form.controls.group.enabled, 'w-full': form.controls.group.disabled }">
          @if (!trailsService.uc$.value && !trailsService.ivca$.value) {
            <label translate app-label class="text-md! text-theme-900">trilhas.relatorio.subdivisao-trilha</label>
          } @else {
            <label translate app-label class="text-md! text-theme-900">trilhas.relatorio.publico-alvo</label>
          }
          @if (!trailsService.uc$.value && !trailsService.ivca$.value) {
            <ng-select
              app-select
              formControlName="item"
              [loading]="loading.courseData$ | async"
              [notFoundText]="'geral.nao-encontrado' | translate"
              [placeholder]="'trilhas.relatorio.selecione-subdivisao-trilha' | translate"
            >
              <ng-container
                *ngTemplateOutlet="
                  subdivisions?.length ? subdivisionsTemplate : trailsTemplate;
                  context: { subdivisions: subdivisions }
                "
              ></ng-container>
              <ng-template #subdivisionsTemplate let-subdivisions="subdivisions">
                @for (subdivision of subdivisions; track subdivision.id) {
                  <ng-option [value]="{ type: 1, value: subdivision }">
                    <span class="font-bold">{{ subdivision?.nome }}</span>
                  </ng-option>
                  @if (subdivision?.trilhas?.length) {
                    @for (trail of subdivision.trilhas; track trail.id) {
                      <ng-option [value]="{ type: 2, value: trail }">
                        <span class="custom ml-8 font-semibold">
                          {{ trail?.titulo }}
                        </span>
                      </ng-option>

                      @for (session of trail.sessoes; track session.id) {
                        <ng-option [value]="{ type: 3, value: session }">
                          <span class="custom ml-16">
                            {{ session?.titulo }}
                          </span>
                        </ng-option>
                      }
                    }
                  } @else {
                    @if (subdivision?.subdivisoes?.length) {
                      <ng-container
                        [ngTemplateOutlet]="subdivisionsTemplate"
                        [ngTemplateOutletContext]="{ subdivisions: subdivision.subdivisoes }"
                      ></ng-container>
                    }
                  }
                }
              </ng-template>
              <ng-template #trailsTemplate let-subdivisions="subdivisions">
                @for (trail of subdivisions?.trilhas; track trail.id) {
                  <ng-option [value]="{ type: 2, value: trail }">
                    <span class="custom font-semibold">
                      {{ trail?.titulo }}
                    </span>
                  </ng-option>
                  @for (session of trail?.sessoes; track session.id) {
                    <ng-option [value]="{ type: 3, value: session }">
                      <span class="custom ml-8">
                        {{ session?.titulo }}
                      </span>
                    </ng-option>
                  }
                }
              </ng-template>
            </ng-select>
          } @else {
            <ng-select
              app-select
              formControlName="audience"
              bindLabel="label"
              [items]="audience"
              [loading]="loading.audience$ | async"
              [notFoundText]="'geral.nao-encontrado' | translate"
              [placeholder]="'trilhas.evento.selecione-função' | translate"
              [multiple]="true"
            ></ng-select>
          }
        </app-form-field>
      </div>
    </form>
  </div>
  @if (form.valid && data$ | async; as data) {
    <div class="md:w-12/12 mb-2 flex w-full flex-col items-center justify-between gap-2 md:flex-row">
      <div class="h-64 w-full rounded-xl bg-[#fefefe] shadow md:w-3/12">
        <div class="flex h-16 items-center justify-start gap-3 rounded-t-xl bg-theme-500 p-3 shadow shadow-black/40">
          <p translate class="text-xl font-semibold text-base-status-info-50">trilhas.relatorio.publico-alvo</p>
          @if (entityActiveType$.value !== 1) {
            <div class="flex items-center justify-center">
              <button
                app-flat-button
                app-tooltip
                (click)="onOpenModal()"
                tooltip="{{ 'trilhas.relatorio.ver-detalhes' | translate }}"
                type="button"
                app-button
                class="group/public bg-[#fefefe] p-2"
              >
                <svg-icon
                  class="w-4 text-theme-500 group-hover/public:text-theme-900"
                  src="assets/icons/icon-arrow-entry.svg"
                ></svg-icon>
              </button>
            </div>
          }
        </div>
        <div class="mt-5 flex flex-col items-start justify-between gap-2 px-10">
          <div class="flex w-full items-center justify-end">
            <p class="text-2xl font-semibold text-theme-950">{{ data.total }}</p>
          </div>
          <div class="mt-3 h-2 w-full rounded-full bg-gray-200">
            <div class="h-2 rounded-full bg-theme-950"></div>
          </div>
        </div>
        <div class="flex items-center justify-between px-10 py-3">
          <p translate class="font-normal text-theme-950 opacity-60">trilhas.relatorio.quantidade-usuarios</p>
        </div>
      </div>
      <div class="h-64 w-full rounded-xl bg-[#fefefe] shadow md:w-3/12">
        <div class="flex h-16 items-center justify-between rounded-t-xl bg-theme-500 p-3 shadow shadow-black/40">
          <p translate class="text-xl font-semibold text-base-status-info-50">trilhas.relatorio.matriculados</p>
        </div>
        <div class="mt-5 flex flex-col items-end justify-between gap-2 px-10">
          <p class="text-2xl font-semibold text-theme-950">{{ data.matriculados.total }}</p>
          <div class="mt-3 h-2 w-full rounded-full bg-gray-200" app-tooltip tooltip="{{ data.matriculados.percent }}%">
            <div class="h-2 rounded-full bg-blue-400" [style.width.%]="data.matriculados.percent"></div>
          </div>
        </div>
        <div class="flex items-center justify-between px-10 py-3">
          <p translate class="font-normal text-theme-950 opacity-60">
            <span class="font-normal text-theme-950"
              >{{ data.matriculados.percent }}% ({{ data.matriculados.total }}/{{ data.total }}) </span
            >trilhas.relatorio.matriculas-efetuadas
          </p>
        </div>
      </div>
      <div class="h-64 w-full rounded-xl bg-[#fefefe] shadow md:w-3/12">
        <div class="flex h-16 items-center justify-between rounded-t-xl bg-theme-500 p-3 shadow shadow-black/40">
          <p translate class="text-xl font-semibold text-base-status-info-50">trilhas.relatorio.andamento</p>
        </div>
        <div class="mt-5 flex flex-col items-end justify-between gap-2 px-10">
          <p class="text-2xl font-semibold text-theme-950">{{ data.iniciados.total }}</p>
          <div class="mt-3 h-2 w-full rounded-full bg-gray-200" app-tooltip tooltip="{{ data.iniciados.percent }}%">
            <div class="h-2 rounded-full bg-base-status-warning" [style.width.%]="data.iniciados.percent"></div>
          </div>
        </div>
        <div class="flex items-center justify-between px-10 py-3">
          <p translate class="font-normal text-theme-900 opacity-60">
            <span class="font-normal text-theme-900"
              >{{ data.iniciados.percent }}% ({{ data.iniciados.total }}/{{ data.total }}) </span
            >trilhas.relatorio.matriculas-efetuadas
          </p>
        </div>
      </div>
      <div class="h-64 w-full rounded-xl bg-[#fefefe] shadow md:w-3/12">
        <div class="flex h-16 items-center justify-between rounded-t-xl bg-theme-500 p-3 shadow shadow-black/40">
          <p translate class="text-xl font-semibold text-base-status-info-50">trilhas.relatorio.concluidos</p>
        </div>
        <div class="mt-5 flex flex-col items-end justify-between gap-2 px-10">
          <p class="text-2xl font-semibold text-theme-950">{{ data.concluidos.total }}</p>
          <div class="mt-3 h-2 w-full rounded-full bg-gray-200" app-tooltip tooltip="{{ data.concluidos.percent }}%">
            <div class="h-2 rounded-full bg-green-400" [style.width.%]="data.concluidos.percent"></div>
          </div>
        </div>
        <div class="flex items-center justify-between px-10 py-3">
          <p translate class="font-normal text-theme-950 opacity-60">
            <span class="font-normal text-theme-950"
              >{{ data.concluidos.percent }}% ({{ data.concluidos.total }}/{{ data.total }}) </span
            >trilhas.relatorio.cursos-concluidos
          </p>
        </div>
      </div>
    </div>
    <div
      class="flex flex-col items-center justify-start gap-2 md:flex-row md:items-start md:justify-between overflow-x-scroll"
    >
      @if (showEntities) {
        <div class="w-full rounded-xl bg-[#fefefe] shadow">
          <div class="flex justify-between">
            <div class="flex items-center px-5">
              <svg-icon
                class="w-6 text-theme-400 group-hover/dots:text-theme-500 md:w-8"
                src="assets/icons/icon-report.svg"
              ></svg-icon>
              <div class="flex h-20 items-center px-5">
                @if (entityType$.value === 3) {
                  <p translate class="text-xl font-semibold text-theme-900">geral.campo</p>
                } @else {
                  <p translate class="text-xl font-semibold text-theme-900">trilhas.relatorio.entidade</p>
                }
              </div>
              <div class="flex">
                <button
                  app-tooltip
                  [tooltip]="'trilhas.relatorio.filtrar' | translate"
                  app-input
                  [ngClass]="{ 'rounded-r-none!': showInputOfEntity }"
                  class="flex h-12! w-12! items-center justify-center rounded-full! border-r-0! focus:border-gray-200!"
                  (click)="onToggleInputOfEntity()"
                >
                  <svg-icon class="w-10 text-theme-500" src="assets/icons/icon-filter.svg"></svg-icon>
                </button>
              </div>
              <div class="rounded-full rounded-l-none" [ngClass]="{ hidden: !showInputOfEntity }">
                <input
                  app-input
                  [formControl]="searchEntityByName"
                  class="block h-12! w-56! rounded-full! rounded-l-none! border-l-0! leading-4! focus:border-gray-200!"
                  type="text"
                  [placeholder]="'trilhas.relatorio.pesquisar' | translate"
                />
              </div>
            </div>
            <div class="flex items-center gap-1 px-5">
              <b> {{ 'trilhas.relatorio.ordernar-por' | translate }}</b>
              @if (filterType$.value === 1 && data.auto_matricula) {
                <p
                  class="flex cursor-pointer items-baseline gap-2 hover:text-green-500"
                  (click)="onOpenFilterPopover(popoverBottom, [strategy.BOTTOM], 1)"
                  #popoverBottom
                >
                  {{ 'trilhas.relatorio.mais-matriculas' | translate }}
                  <svg-icon
                    class="flex w-3 transition-transform duration-300"
                    src="assets/icons/icon-arrow-down.svg"
                    [ngClass]="{ 'rotate-180': isPopoverVisible }"
                  ></svg-icon>
                </p>
              }
              @if (filterType$.value === 2 && data.auto_matricula) {
                <p
                  class="flex cursor-pointer items-baseline gap-2 hover:text-green-500"
                  (click)="onOpenFilterPopover(popoverBottom, [strategy.BOTTOM], 2)"
                  #popoverBottom
                >
                  {{ 'trilhas.relatorio.menos-matriculas' | translate }}
                  <svg-icon
                    class="flex w-3 transition-transform duration-300"
                    src="assets/icons/icon-arrow-down.svg"
                    [ngClass]="{ 'rotate-180': isPopoverVisible }"
                  ></svg-icon>
                </p>
              }
              @if (filterType$.value === 3 && !data.auto_matricula) {
                <p
                  class="flex cursor-pointer items-baseline gap-2 hover:text-green-500"
                  (click)="onOpenFilterPopover(popoverBottom, [strategy.BOTTOM], 3)"
                  #popoverBottom
                >
                  {{ 'trilhas.relatorio.mais-andamento' | translate }}
                  <svg-icon
                    class="flex w-3 transition-transform duration-300"
                    src="assets/icons/icon-arrow-down.svg"
                    [ngClass]="{ 'rotate-180': isPopoverVisible }"
                  ></svg-icon>
                </p>
              }
              @if (filterType$.value === 4 && !data.auto_matricula) {
                <p
                  class="flex cursor-pointer items-baseline gap-2 hover:text-green-500"
                  (click)="onOpenFilterPopover(popoverBottom, [strategy.BOTTOM], 4)"
                  #popoverBottom
                >
                  {{ 'trilhas.relatorio.menos-andamento' | translate }}
                  <svg-icon
                    class="flex w-3 transition-transform duration-300"
                    src="assets/icons/icon-arrow-down.svg"
                    [ngClass]="{ 'rotate-180': isPopoverVisible }"
                  ></svg-icon>
                </p>
              }
              @if (filterType$.value === 5) {
                <p
                  class="flex cursor-pointer items-baseline gap-2 hover:text-green-500"
                  (click)="onOpenFilterPopover(popoverBottom, [strategy.BOTTOM], 5)"
                  #popoverBottom
                >
                  {{ 'trilhas.relatorio.mais-concluidos' | translate }}
                  <svg-icon
                    class="flex w-3 transition-transform duration-300"
                    src="assets/icons/icon-arrow-down.svg"
                    [ngClass]="{ 'rotate-180': isPopoverVisible }"
                  ></svg-icon>
                </p>
              }
              @if (filterType$.value === 6) {
                <p
                  class="flex cursor-pointer items-baseline gap-2 hover:text-green-500"
                  (click)="onOpenFilterPopover(popoverBottom, [strategy.BOTTOM], 6)"
                  #popoverBottom
                >
                  {{ 'trilhas.relatorio.menos-concluidos' | translate }}
                  <svg-icon
                    class="flex w-3 transition-transform duration-300"
                    src="assets/icons/icon-arrow-down.svg"
                    [ngClass]="{ 'rotate-180': isPopoverVisible }"
                  ></svg-icon>
                </p>
              }
            </div>
          </div>
          <hr app-divider />
          <div class="max-h-[62.7vh] overflow-y-auto p-5">
            @for (entity of data.entidades | filter: searchEntityByName.value : ['nome']; track entity.id) {
              <div
                (click)="onClickEntity(entity)"
                class="group mt-2 flex w-full cursor-pointer items-center justify-between rounded-lg bg-[#fefefe] py-6 pr-3 shadow shadow-black/40 hover:bg-[#f4fdfd]"
              >
                <div class="flex w-5/12 flex-col items-start justify-center pl-4">
                  <p class="pl-4text-md! font-semibold text-theme-900">
                    {{ entity.abreviatura }}
                  </p>
                  <p class="pl-4text-md! text-theme-500">
                    {{ entity.nome }}
                  </p>
                  <p translate class="pl-4text-md! font-semibold text-theme-300">
                    trilhas.relatorio.publico-alvo<span>: </span
                    ><span class="pl-4text-md! font-semibold text-theme-300">{{ entity.total }}</span>
                  </p>
                </div>
                @if (data.auto_matricula) {
                  <div class="group/matriculado flex w-3/12 flex-col items-center justify-center">
                    <p
                      translate
                      class="text-center text-base text-theme-700 opacity-0 group-hover/matriculado:opacity-100"
                    >
                      trilhas.relatorio.matriculados<span>: </span>
                      <span> {{ entity.total_matriculados }} de {{ entity.total }}</span>
                    </p>
                    <div class="relative h-12 w-12">
                      <svg class="h-full w-full" viewBox="0 0 100 100">
                        <circle
                          class="stroke-current text-gray-200"
                          stroke-width="8"
                          cx="50"
                          cy="50"
                          r="40"
                          fill="transparent"
                        ></circle>
                        <circle
                          class="progress-ring__circle stroke-current text-blue-500"
                          stroke-width="8"
                          stroke-linecap="round"
                          cx="50"
                          cy="50"
                          r="40"
                          fill="transparent"
                          [attr.stroke-dasharray]="circumference"
                          [attr.stroke-dashoffset]="onStokeDashoffset(entity.percent_matriculados)"
                        ></circle>
                      </svg>
                    </div>
                    <p class="text-center font-goldplay text-base text-theme-900">{{ entity.percent_matriculados }}%</p>
                    <p translate class="text-center font-goldplay text-base text-theme-900">
                      trilhas.relatorio.matriculados
                    </p>
                  </div>
                } @else {
                  <div class="group/andamento flex w-3/12 flex-col items-center justify-center">
                    <p
                      translate
                      class="text-center text-base text-theme-700 opacity-0 group-hover/andamento:opacity-100"
                    >
                      trilhas.relatorio.andamento<span>: </span>
                      <span> {{ entity.total_iniciados }} de {{ entity.total }}</span>
                    </p>
                    <div class="relative h-12 w-12">
                      <svg class="h-full w-full" viewBox="0 0 100 100">
                        <circle
                          class="stroke-current text-gray-200"
                          stroke-width="8"
                          cx="50"
                          cy="50"
                          r="40"
                          fill="transparent"
                        ></circle>
                        <circle
                          class="progress-ring__circle stroke-current text-blue-500"
                          stroke-width="8"
                          stroke-linecap="round"
                          cx="50"
                          cy="50"
                          r="40"
                          fill="transparent"
                          [attr.stroke-dasharray]="circumference"
                          [attr.stroke-dashoffset]="onStokeDashoffset(entity.percent_iniciados)"
                        ></circle>
                      </svg>
                    </div>
                    <p class="text-center font-goldplay text-base text-theme-900">{{ entity.percent_iniciados }}%</p>
                    <p translate class="text-center font-goldplay text-base text-theme-900">
                      trilhas.relatorio.andamento
                    </p>
                  </div>
                }
                <div class="group/concluidos flex w-3/12 flex-col items-center justify-center">
                  <p translate class="text-center text-sm text-theme-700 opacity-0 group-hover/concluidos:opacity-100">
                    trilhas.relatorio.concluidos<span>: </span>
                    <span> {{ entity.total_concluidos }} de {{ entity.total }}</span>
                  </p>
                  <div class="relative h-12 w-12">
                    <svg class="h-full w-full" viewBox="0 0 100 100">
                      <circle
                        class="stroke-current text-gray-200"
                        stroke-width="8"
                        cx="50"
                        cy="50"
                        r="40"
                        fill="transparent"
                      ></circle>
                      <circle
                        class="progress-ring__circle stroke-current text-blue-500"
                        stroke-width="8"
                        stroke-linecap="round"
                        cx="50"
                        cy="50"
                        r="40"
                        fill="transparent"
                        [attr.stroke-dasharray]="circumference"
                        [attr.stroke-dashoffset]="onStokeDashoffset(entity.percent_concluidos)"
                      ></circle>
                    </svg>
                  </div>
                  <p class="text-center font-goldplay text-base text-theme-900">{{ entity.percent_concluidos }}%</p>
                  <p translate class="text-center font-goldplay text-base text-theme-900">
                    trilhas.relatorio.concluidos
                  </p>
                </div>
                <div class="flex w-1/12 items-center justify-center">
                  <button
                    app-outline-button
                    app-tooltip
                    tooltip="{{ 'trilhas.relatorio.ver-progresso' | translate }}"
                    type="button"
                    app-button
                    class="group/dots"
                  >
                    <svg-icon
                      class="w-8 cursor-pointer text-green-700"
                      src="assets/icons/icon-eyes.svg"
                      alt="icon-eyes.svg"
                    ></svg-icon>
                  </button>
                </div>
                <div class="flex w-1/12 items-center justify-center">
                  <button
                    app-outline-button
                    app-tooltip
                    (click)="onChangeEntityReference(entity)"
                    tooltip="{{ 'trilhas.relatorio.ver-detalhes' | translate }}"
                    type="button"
                    app-button
                    class="group/dots"
                  >
                    <svg-icon
                      class="w-6 text-theme-400 group-hover/dots:text-theme-500 md:w-8"
                      src="assets/icons/icon-list.svg"
                    ></svg-icon>
                  </button>
                </div>
              </div>
            }
          </div>
        </div>
      }
      <div class="w-full">
        <div class="w-full rounded-xl bg-[#fefefe] shadow">
          <div class="w-full">
            <div class="flex h-20 items-center justify-between">
              <div class="flex items-center px-5">
                <svg-icon
                  class="w-6 text-theme-400 group-hover/dots:text-theme-500 md:w-8"
                  src="assets/icons/icon-report.svg"
                ></svg-icon>
                <div class="p-5">
                  <p translate class="text-xl font-semibold text-theme-900">trilhas.relatorio.progresso</p>
                </div>
              </div>
              @if (isSchoolSelected) {
                <div class="flex px-2 w-full items-center">
                  <div class="mx-5 mt-6 w-56">
                    <app-form-field class="w-full">
                      <ng-select
                        app-select
                        [items]="optionsUserStatus"
                        [formControl]="selectUserStatus"
                        bindValue="value"
                        [clearable]="false"
                        [searchable]="false"
                      >
                        <ng-template ng-label-tmp ng-option-tmp let-item="item">
                          <span
                            class="rounded px-2 py-1 text-xs font-semibold uppercase text-white"
                            [ngClass]="{
                              'bg-blue-950': item.value === FilterStatusEnum.All,
                              'bg-red-400': item.value === FilterStatusEnum.NotEnrolled,
                              'bg-blue-400': item.value === FilterStatusEnum.NotStarted,
                              'bg-base-status-warning': item.value === FilterStatusEnum.Started,
                              'bg-green-400': item.value === FilterStatusEnum.Completed,
                            }"
                          >
                            {{ item.label | translate }}
                          </span>
                        </ng-template>
                      </ng-select>
                    </app-form-field>
                  </div>
                  <div class="flex items-center justify-start rounded-full bg-white">
                    <div class="flex">
                      <button
                        app-tooltip
                        [tooltip]="'trilhas.relatorio.filtrar' | translate"
                        app-input
                        [ngClass]="{ 'rounded-r-none!': showInputOfUser }"
                        class="flex h-12! w-12! items-center justify-center rounded-full! border-r-0! focus:border-gray-200!"
                        (click)="onToggleInputOfUser()"
                      >
                        <svg-icon class="w-10 text-theme-500" src="assets/icons/icon-filter.svg"></svg-icon>
                      </button>
                    </div>
                    <div class="rounded-full rounded-l-none" [ngClass]="{ hidden: !showInputOfUser }">
                      <input
                        app-input
                        [formControl]="searchUserByName"
                        class="block h-12! w-56! rounded-full! rounded-l-none! border-l-0! leading-4! focus:border-gray-200!"
                        type="text"
                        [placeholder]="'trilhas.relatorio.pesquisar' | translate"
                      />
                    </div>
                  </div>
                  @if (users$ | async; as usersData) {
                    @if (usersData.users && usersData.users.length > 0) {
                      <div class="flex items-center justify-between gap-2">
                        <button
                          #progressOptions
                          (click)="onOpenPopover(progressOptions, [strategy.BOTTOM], usersData)"
                          app-outline-button
                          type="button"
                          app-button
                          class="group/dots"
                        >
                          <svg-icon
                            class="w-8 h-6 flex justify-center text-theme-700 hover:text-theme-500 md:w-10"
                            src="assets/icons/icon-three-dots.svg"
                          ></svg-icon>
                        </button>
                      </div>
                    }
                  }
                </div>
              }
            </div>
            <hr app-divider />
            @if (!!isSchoolSelected) {
              <div class="mx-5 mt-2 max-h-[62vh] overflow-x-auto overflow-y-auto py-5">
                @if (users$ | async; as usersData) {
                  @if (usersData.users && usersData.users.length > 0) {
                    <table app-table class="w-full border-separate border-spacing-0.5 border-spacing-y-0.5">
                      <thead class="text-center">
                        <th
                          translate
                          class="w-3/12 whitespace-nowrap bg-theme-500! px-4 py-2 text-left text-base! uppercase text-theme-contrast first:rounded-l-lg last:rounded-r-lg [th]:bg-theme-500 [th]:text-theme-contrast [&:not(th)]:bg-white"
                        >
                          trilhas.relatorio.nome
                        </th>
                        <th
                          translate
                          class="w-2/12 whitespace-nowrap bg-theme-500! px-4 py-2 text-left text-base! uppercase text-theme-contrast first:rounded-l-lg last:rounded-r-lg [th]:bg-theme-500 [th]:text-theme-contrast [&:not(th)]:bg-white"
                        >
                          trilhas.relatorio.progresso
                        </th>
                        <th
                          translate
                          class="w-3/12 whitespace-nowrap bg-theme-500! px-4 py-2 text-left text-base! uppercase text-theme-contrast first:rounded-l-lg last:rounded-r-lg [th]:bg-theme-500 [th]:text-theme-contrast [&:not(th)]:bg-white"
                        >
                          trilhas.relatorio.periodo
                        </th>
                        @if (hasCertificate$ | async) {
                          <th
                            translate
                            app-table-cell
                            class="w-1/12 whitespace-nowrap bg-theme-500! px-4 py-2 text-center text-base! uppercase text-theme-contrast first:rounded-l-lg last:rounded-r-lg [th]:bg-theme-500 [th]:text-theme-contrast [&:not(th)]:bg-white"
                          >
                            trilhas.relatorio.certificado
                          </th>
                        }
                        @if (usersData.exige_voucher) {
                          <th
                            translate
                            class="w-1/12 whitespace-nowrap bg-theme-500! px-4 py-2 text-center text-base! uppercase text-theme-contrast first:rounded-l-lg last:rounded-r-lg [th]:bg-theme-500 [th]:text-theme-contrast [&:not(th)]:bg-white"
                          >
                            trilhas.estudio.curso.voucher
                          </th>
                        }
                      </thead>
                      <tbody>
                        @for (user of usersData.users; track user.id) {
                          <tr class="group odd:bg-white! even:bg-theme-50!">
                            <td class="border-b border-b-theme-200 p-4! text-left group-hover:bg-theme-200!">
                              <p class="text-base">{{ user.nome }}</p>
                            </td>
                            <td class="border-b border-b-theme-200 px-5! py-4! text-center group-hover:bg-theme-200!">
                              @switch (user.status) {
                                @case (FilterStatusEnum.NotEnrolled) {
                                  <span class="rounded bg-red-400 px-2 py-1 text-xs font-semibold uppercase text-white">
                                    {{ 'trilhas.relatorio.user-status-options.nao-matriculado' | translate }}
                                  </span>
                                }
                                @case (FilterStatusEnum.NotStarted) {
                                  <span
                                    class="rounded bg-blue-400 px-2 py-1 text-xs font-semibold uppercase text-white"
                                  >
                                    {{ 'trilhas.relatorio.user-status-options.nao-iniciado' | translate }}
                                  </span>
                                }
                                @case (FilterStatusEnum.Started) {
                                  <div class="mt-3 h-2 w-full rounded-full bg-gray-200">
                                    <div
                                      class="mb-1 h-2 rounded-full bg-base-status-warning"
                                      [style.width.%]="user.percent"
                                    ></div>
                                  </div>
                                  {{ user.percent }}%
                                }
                                @case (FilterStatusEnum.Completed) {
                                  <span
                                    class="rounded bg-green-400 px-2 py-1 text-xs font-semibold uppercase text-white"
                                  >
                                    {{ 'trilhas.relatorio.user-status-options.concluido' | translate }}
                                  </span>
                                }
                              }
                            </td>
                            <td class="border-b border-b-theme-200 p-4! text-left group-hover:bg-theme-200!">
                              <div class="flex items-center justify-start gap-4">
                                <p translate class="w-24 font-bold text-theme-900">trilhas.relatorio.data-ini</p>
                                <p class="w-20 text-center text-base">
                                  {{ user.data_inicio ? (user.data_inicio | date: 'dd/MM/yyyy') : '-' }}
                                </p>
                              </div>
                              <div class="flex items-center justify-start gap-4">
                                <p translate class="w-24 font-bold text-theme-900">trilhas.relatorio.data-fim</p>
                                <p class="w-20 text-center text-base">
                                  {{ user.data_conclusao ? (user.data_conclusao | date: 'dd/MM/yyyy') : '-' }}
                                </p>
                              </div>
                            </td>
                            @if (hasCertificate$ | async) {
                              <td
                                class="relative whitespace-nowrap border-b border-b-theme-200 p-4! text-center group-hover:bg-theme-200!"
                              >
                                <div class="flex flex-col items-center justify-between">
                                  @if (user.data_conclusao && hasCertificate$ | async) {
                                    <button
                                      (click)="onRedeemCertificate(user.uuid)"
                                      class="group/certificate flex items-center justify-center bg-[#fefefe]! hover:bg-[#fefefe]!"
                                      app-flat-button
                                      type="button"
                                      app-tooltip
                                      [tooltip]="onStateCertificate(user)"
                                    >
                                      <svg-icon
                                        class="flex w-10"
                                        [ngClass]="{
                                          'text-blue-400': !user.data_impressao,
                                          'text-green-400': user.data_impressao,
                                        }"
                                        src="assets/icons/icon-certified.svg"
                                      ></svg-icon>
                                    </button>
                                  } @else {
                                    -
                                  }
                                </div>
                              </td>
                            }
                            @if (usersData.exige_voucher) {
                              <td class="border-b border-b-theme-200 p-4! text-center group-hover:bg-theme-200!">
                                <div class="flex h-full items-center justify-center">
                                  <svg-icon
                                    class="w-7 text-theme-500"
                                    src="assets/icons/icon-checked-circle.svg"
                                  ></svg-icon>
                                </div>
                              </td>
                            }
                          </tr>
                        }
                      </tbody>
                    </table>
                  } @else {
                    <app-jumbotron class="py-50 px-5" translate> geral.filtro-vazio </app-jumbotron>
                  }
                } @else {
                  <div class="py-50 h-96">
                    <app-skeleton></app-skeleton>
                  </div>
                }
              </div>
            } @else {
              <app-jumbotron class="py-50 px-5 text-center" translate>
                trilhas.relatorio.visualize-progresso
              </app-jumbotron>
            }
          </div>
        </div>
      </div>
    </div>
  } @else {
    @if (!form.valid) {
      <app-card>
        <div app-card-content class="h-[200px]">
          <app-jumbotron translate> trilhas.relatorio.selecione-filtros </app-jumbotron>
        </div>
      </app-card>
    }
    @if (form.valid) {
      <div class="mb-2 flex w-full flex-col items-center justify-between gap-2">
        <div class="md:w-12/12 mb-2 flex w-full flex-col items-center justify-between gap-2 md:flex-row">
          <div class="w-full rounded-xl bg-[#fefefe] md:w-3/12">
            <div
              class="flex h-16 items-center justify-start gap-3 rounded-t-xl bg-theme-500 p-3 shadow shadow-black/40"
            >
              <p translate class="text-xl font-semibold text-base-status-info-50">trilhas.relatorio.publico-alvo</p>
            </div>
            <div class="mx-5 h-44 overflow-x-auto overflow-y-auto py-5">
              <app-skeleton></app-skeleton>
            </div>
          </div>
          <div class="w-full rounded-xl bg-[#fefefe] md:w-3/12">
            <div class="flex h-16 items-center justify-between rounded-t-xl bg-theme-500 p-3 shadow shadow-black/40">
              <p translate class="text-xl font-semibold text-base-status-info-50">trilhas.relatorio.matriculados</p>
            </div>
            <div class="mx-5 h-44 overflow-x-auto overflow-y-auto py-5">
              <app-skeleton></app-skeleton>
            </div>
          </div>
          <div class="w-full rounded-xl bg-[#fefefe] md:w-3/12">
            <div class="flex h-16 items-center justify-between rounded-t-xl bg-theme-500 p-3 shadow shadow-black/40">
              <p translate class="text-xl font-semibold text-base-status-info-50">trilhas.relatorio.andamento</p>
            </div>
            <div class="mx-5 h-44 overflow-x-auto overflow-y-auto py-5">
              <app-skeleton></app-skeleton>
            </div>
          </div>
          <div class="w-full rounded-xl bg-[#fefefe] md:w-3/12">
            <div class="flex h-16 items-center justify-between rounded-t-xl bg-theme-500 p-3 shadow shadow-black/40">
              <p translate class="text-xl font-semibold text-base-status-info-50">trilhas.relatorio.concluidos</p>
            </div>
            <div class="mx-5 h-44 overflow-x-auto overflow-y-auto py-5">
              <app-skeleton></app-skeleton>
            </div>
          </div>
        </div>
        <div class="justfy-start flex w-full flex-col items-center gap-2 md:flex-row md:items-start md:justify-between">
          @if (showEntities) {
            <div class="w-full rounded-xl bg-[#fefefe] shadow">
              <div class="flex items-center px-5">
                <svg-icon
                  class="w-6 text-theme-400 group-hover/dots:text-theme-500 md:w-8"
                  src="assets/icons/icon-report.svg"
                ></svg-icon>
                <div class="h-20 p-5">
                  <p translate class="text-xl font-semibold text-theme-900">trilhas.relatorio.entidade</p>
                </div>
              </div>
              <hr app-divider />
              <div class="mx-5 mt-2 h-[30vh] overflow-x-auto overflow-y-auto py-5">
                <app-skeleton></app-skeleton>
              </div>
            </div>
          }
          <div class="w-full">
            <div class="w-full rounded-xl bg-[#fefefe] shadow">
              <div class="w-full">
                <div class="flex h-20 items-center justify-between">
                  <div class="flex items-center px-5">
                    <svg-icon
                      class="w-6 text-theme-400 group-hover/dots:text-theme-500 md:w-8"
                      src="assets/icons/icon-report.svg"
                    ></svg-icon>
                    <div class="p-5">
                      <p translate class="text-xl font-semibold text-theme-900">trilhas.relatorio.progresso</p>
                    </div>
                  </div>
                </div>
                <hr app-divider />
                <div class="mx-5 mt-2 h-[30vh] overflow-x-auto overflow-y-auto py-5">
                  <app-skeleton></app-skeleton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  }
</div>
